import React from 'react';
import { Box, Paper, Typography, withStyles } from '@material-ui/core';

const styles = theme => ({
    container: {
        border: "1px solid #DEE2E6",
        borderRadius: "0.375rem",
        backgroundColor: theme.palette.background.paper,
    },
    list: {
        padding: "0.75rem 1rem",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        boxShadow: "none",
        backgroundColor: "transparent",
        borderBottom: "1px solid #DEE2E6",
        "&:last-child": {
            marginBottom: "0",
            borderBottom: "none",
        },
    },
    listContent: {
        flex: 1,
        minWidth: 0,
    },
    listTitle: {
        fontSize: "1rem",
        fontWeight: "600",
        lineHeight: "1.5",
        color: theme.palette.text.primary,
        marginBottom: "0.5rem",
    },
    listDescription: {
        fontSize: "0.875rem",
        fontWeight: "400",
        lineHeight: "1.4",
        color: theme.palette.text.secondary,
        whiteSpace: "pre-line",
    },
    descriptionList: {
        margin: 0,
        padding: 0,
        listStyle: "none",
    },
    descriptionListItem: {
        fontSize: "0.875rem",
        fontWeight: "400",
        lineHeight: "1.4",
        color: theme.palette.text.secondary,
        marginBottom: "0.25rem",
        "&:last-child": {
            marginBottom: 0,
        },
    },
    listActions: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        flexShrink: 0,
        marginLeft: "1rem",
    },
    emptyState: {
        padding: "2rem",
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
});

const FlatList = ({
    classes,
    items,
    renderItem,
    currentLanguage,
    emptyMessage,
    descriptionType = "text",
    ...props
}) => {
    const defaultEmptyMessage = emptyMessage || currentLanguage?.bepiService?.shared.shared_flat_list_empty_msg || "Nenhum item encontrado";
    const defaultTitle = currentLanguage?.bepiService?.shared.shared_flat_list_no_title || "Sem título";

    const renderDescription = (description) => {
        if (descriptionType === 'list' && Array.isArray(description)) {
            return (
                <ul className={classes.descriptionList}>
                    {description.map((item, index) => (
                        <li key={index} className={classes.descriptionListItem}>
                            {item}
                        </li>
                    ))}
                </ul>
            );
        }

        if (typeof description === 'string' && description.includes('\n')) {
            return (
                <Typography className={classes.listDescription} style={{ whiteSpace: 'pre-line' }}>
                    {description}
                </Typography>
            );
        }

        return (
            <Typography className={classes.listDescription}>
                {description}
            </Typography>
        );
    };

    if (renderItem) {
        return (
            <Box className={classes.container} {...props}>
                {items.length > 0 ? (
                    items.map((item, index) => (
                        <Paper key={item.id || index} className={classes.list}>
                            {renderItem(item, index)}
                        </Paper>
                    ))
                ) : (
                    <Typography className={classes.emptyState}>
                        {defaultEmptyMessage}
                    </Typography>
                )}
            </Box>
        );
    }

    return (
        <Box className={classes.container} {...props}>
            {items.length > 0 ? (
                items.map((item, index) => (
                    <Paper key={item.id || index} className={classes.list}>
                        <Box className={classes.listContent}>
                            <Typography className={classes.listTitle}>
                                {item.title || defaultTitle}
                            </Typography>
                            {item.description && renderDescription(item.description)}
                        </Box>

                        {item.actions && (
                            <Box className={classes.listActions}>
                                {item.actions}
                            </Box>
                        )}
                    </Paper>
                ))
            ) : (
                <Typography className={classes.emptyState}>
                    {defaultEmptyMessage}
                </Typography>
            )}
        </Box>
    );
};

export default withStyles(styles)(FlatList);
